import React, { Component } from 'react';
import Slider from 'react-slick';

import VideoPlayer from '../VideoPlayer';
import VideoCard from '../VideoCard';

import './index.scss';

export default class Carousel extends Component {
  state = {
    activeSlides: [],
    selectedSlideIndex: 0,
    navSliderRef: null,
    videoSliderRef: null,
    isFetchingData: false,
  };

  onNavSlideChange = index => {
    const {
      data: { items, pageNum, pageCount },
      fetchMoreVideos,
    } = this.props;
    const { isFetchingData } = this.state;
    const fetchingIndent = 5;

    if (
      isFetchingData ||
      items.length - fetchingIndent > index ||
      pageNum >= pageCount
    ) {
      return;
    }

    this.setState(
      state => ({
        ...state,
        isFetchingData: true,
      }),
      () => fetchMoreVideos(),
    );
  };

  onNavSlideClick = index => {
    this.state.videoSliderRef.slickGoTo(index);
    this.setState(
      state => ({
        ...state,
        selectedSlideIndex: index,
      }),
    );
  };

  onViewSlideChange = index => {
    this.state.navSliderRef.slickGoTo(index);
    this.setState(state => ({
      ...state,
      activeSlides: state.activeSlides.map(
        (active, i) => active && i === index,
      ),
    }));
  };

  onViewSliderPlay = index => {
    this.setState(state => ({
      ...state,
      activeSlides: state.activeSlides.map((_, i) => i === index),
    }));
  };

  componentDidMount() {
    const { items } = this.props.data;

    this.setState(state => ({
      ...state,
      activeSlides: items.map(() => false),
      videoSliderRef: this.viewSlider,
      navSliderRef: this.navSlider,
    }));
  }

  componentDidUpdate() {
    const { items } = this.props.data;
    const { activeSlides, isFetchingData } = this.state;

    if (isFetchingData && activeSlides.length < items.length) {
      this.setState(state => ({
        ...state,
        activeSlides: items.map(() => false),
        isFetchingData: false,
      }));
    }
  }

  render() {
    const { videoSliderRef, navSliderRef, activeSlides } = this.state;
    const { t, data: { items } = { items: [] } } = this.props;

    const navSliderConfig = {
      asNavFor: videoSliderRef,
      centerMode: false,
      focusOnSelect: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
      slidesToScroll: 1,
      slidesToShow: 3,
      swipeToSlide: true,
      variableWidth: true,
      afterChange: this.onNavSlideChange,
      ref: slider => {
        this.navSlider = slider;
      },
    };

    const viewSliderConfig = {
      arrows: false,
      asNavFor: navSliderRef,
      autoplaySpeed: 10000,
      focusOnSelect: true,
      infinite: false,
      slidesToShow: 1,
      afterChange: this.onViewSlideChange,
      ref: slider => {
        this.viewSlider = slider;
      },
    };

    return (
      <div className="carousel">
        <div className="view-slides">
          <Slider {...viewSliderConfig}>
            {items.map(({ title, imageSrc, videoSrc }, i) => (
              <li className="slider-view" key={i}>
                <VideoPlayer
                  t={t}
                  src={videoSrc}
                  preview={imageSrc}
                  active={activeSlides[i]}
                  text={title}
                  onPlay={() => this.onViewSliderPlay(i)}
                />
              </li>
            ))}
          </Slider>
        </div>
        <div className="navs-slides">
          <Slider {...navSliderConfig}>
            {items.map(({ title, imageSrc }, i) => (
              <li className="slider-view" key={i}>
                <VideoCard
                  src={imageSrc}
                  text={title}
                  onClick={() => this.onNavSlideClick(i)}
                  isActive={i===this.state.selectedSlideIndex}
                />
              </li>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /app/apps/ms/src/components/Carousel/Carousel/index.js